// import { forceWebSockets, getDatabase } from '@firebase/database'
import { initializeFirestore } from '@firebase/firestore'
import { initializeApp } from '@firebase/app'
import { getAuthDomain } from '../global'
import { getAuth } from '@firebase/auth'

// import { getFunctions } from '@firebase/functions'

// forceWebSockets()

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyD32ApJ1TAeicMT7J30qA4ybh6Q1S_z7wg',
  authDomain: getAuthDomain(), //'konpi-379314.firebaseapp.com'
  projectId: 'konpi-379314',
  storageBucket: 'konpi-379314.appspot.com',
  messagingSenderId: '772964378802',
  appId: '1:772964378802:web:e5d338ab393fc96b1e81ab',
  databaseURL:
    'https://konpi-379314-default-rtdb.asia-southeast1.firebasedatabase.app',
}

export const firebaseFcmStorageId = 'firebasePushId'

export const app = initializeApp(firebaseConfig)

export const firestore = initializeFirestore(app, {
  // https://github.com/firebase/firebase-js-sdk/issues/1674
  // experimentalForceLongPolling: true,
})

// export const database = getDatabase(app)

// TODO: get edge-server location from middleware if able
const serverLocation = 'europe-west1'
// export const functions = getFunctions(app, serverLocation)

export const auth = getAuth(app)

// TODO: we should implement this ourselves for SSR compat and GDPR compliance
// https://github.com/firebase/firebase-js-sdk/issues/6645
// https://github.com/firebase/firebase-js-sdk/discussions/5095
// export const appCheck =
//   typeof document !== 'undefined' &&
//   initializeAppCheck(app, {
//     provider: new ReCaptchaV3Provider(
//       '6Ld4dsEkAAAAAI-ieRMB6V-FdaoaMJk6O02lS8U6'
//     ),
//     isTokenAutoRefreshEnabled: true,
//   })

// export { connectFunctionsEmulator, httpsCallable } from '@firebase/functions'
export {
  addDoc,
  arrayUnion,
  collection,
  connectFirestoreEmulator,
  deleteDoc,
  doc,
  documentId,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from '@firebase/firestore'
// export {
//   connectDatabaseEmulator,
//   onChildAdded,
//   onChildRemoved,
//   onDisconnect,
//   onValue,
//   ref,
//   remove,
//   set,
//   update,
// } from '@firebase/database'
export {
  FacebookAuthProvider,
  GithubAuthProvider,
  GoogleAuthProvider,
  TwitterAuthProvider,
  connectAuthEmulator,
  getAdditionalUserInfo,
  isSignInWithEmailLink,
  linkWithCredential,
  onAuthStateChanged,
  sendSignInLinkToEmail,
  signInAnonymously,
  signInWithCustomToken,
  signInWithEmailLink,
  signInWithRedirect,
  signOut,
} from '@firebase/auth'
export { onIdTokenChanged } from '@firebase/auth'

export const useAuth = () => auth
export const useFirestore = () => firestore
// export const useFunctions = () => functions
